/**
 * Metadados dos Acionamentos manuais (protótipo v5.10 — `buildQuickActions`).
 * Config de apresentação (ícone/cor/rótulo). Sem PII: contatos vêm do banco.
 * A resolução do código→nível vem do catálogo de domínio (não é duplicada aqui).
 */
import type { TarpCode } from '@/domain';
import type { QuickActionIconName } from './QuickActionIcon';

export interface QuickAction {
  code: TarpCode;
  iconName: QuickActionIconName;
  label: string;
  sub: string;
  /** Cor do card (borda/fundo/ícone) — fiel ao protótipo v5.10. */
  color: string;
}

/** Os 5 acionamentos manuais do protótipo v5.10, na ordem exata da Página Inicial. */
export const QUICK_ACTIONS = [
  {
    code: 'TARP-VIS-AL',
    iconName: 'camera',
    label: 'Vi algo anormal nas câmeras',
    sub: 'Iniciar fluxo visual',
    color: '#f97316',
  },
  {
    code: 'TARP-PS-CAM',
    iconName: 'no-signal',
    label: 'Câmeras sem sinal',
    sub: 'Perda de transmissão',
    color: '#eab308',
  },
  {
    code: 'TARP-PS-INST',
    iconName: 'no-signal',
    label: 'Instrumento sem sinal',
    sub: 'Perda de leitura',
    color: '#78B4CF',
  },
  {
    code: 'TARP-PS-TILT',
    iconName: 'bolt',
    label: 'Tiltímetros perderam sinal',
    sub: 'Verificação imediata',
    color: '#f87171',
  },
  {
    code: 'TARP-EMG',
    iconName: 'sos',
    label: 'EMERGÊNCIA · Ruptura em curso',
    sub: 'Acionar protocolo PAEBM',
    color: '#ef4444',
  },
] as const satisfies readonly QuickAction[];
